// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31NiY","type":"styles_type__11CAC","choices":"styles_choices__bH4c9"};